import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class InvestmentsHeldPartnershipComponentService {

  URl = this.ConfigService.getAPIBaseUrl() + 'api/InvestmentsHeldAsCurrentAssets/';
  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveInvestmentsHeldPartnership(InvestmentsHeldPartnership) {
    debugger;
    return this.HttpClient.post(this.URl + 'InsertInvestmentsHeld', InvestmentsHeldPartnership)
  } 
  GetOneInvestmentsHeldPartnership(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URl + "GetInvestmentsHeld?APPeriodId=" + APPeriodId)
  }
  GetOneInvestmentsHeldPartnership_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URl + "GetInvestmentsHeld_LY?APPeriodId=" + APPeriodId)
  }
  
}
